import React from "react";
import Main from "../components/layout/Main";
import {QueryProgress} from "../components/query-builder/QueryProgress";
import {COHORT_ANALYSER_TITLE, QB_TITLE} from "./QueryBuilderPage";

interface QueryBuilderProgressPageProps {
    isCohortAnalyser: boolean
}

export const QueryBuilderProgressPage = ({isCohortAnalyser}: QueryBuilderProgressPageProps) => {
    return <Main title={isCohortAnalyser ? COHORT_ANALYSER_TITLE : QB_TITLE}>
        <QueryProgress isCohortAnalyser={isCohortAnalyser}/>
    </Main>
}